module.exports = __webpack_public_path__ + "media/images/shadow-cdf9b17a2f1a1c82fac62de9fec7599f.png";